import { configInitialValuesBase, configKeysForCloud } from '../../helper/configs'
import { globalOnDemandVars } from '../../helper/context'
import { configInitialValues } from './initData'
import { debounce } from 'lodash'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'
import Firestore from '../initFirebase'
import { produce } from 'immer'

const mutateConfigAsync = async (inputObj) => {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'appsync update 2',
      value: {
        inputObj
      }
    // , important: true
    })
  }
  try {
    savingStart()
    await Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('Config').doc('config').update(inputObj)
    savingEnd()
  } catch (e) {
    handleErrorInCatch(e, 'updateData.js 1')
  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('appsync update 3')
  }
}

// const mutateConfig = (inputObj) => {
//   console.tron.display({
//     name: 'appsync update 2',
//     value: {
//       inputObj
//     }
//     // , important: true
//   })
//   client.mutate(buildMutation(client,
//     gql(updateConfig),
//     {
//       inputType: gql(UpdateConfigInput),
//       variables: {
//         input: {
//           id: '002',
//           ...inputObj
//         }
//       }
//     },
//     (_variables) => [ gql(getConfig) ],
//     'Config'))
//   console.tron.log('appsync update 3')
// }

export function updateConfigToCloud (keysToUpdate = configKeysForCloud) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  if (globalOnDemandVars.configReady() && !globalOnDemandVars.isMosaicWindowDragging()) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('appsync update 1')
    }
    const inputObj = {}
    keysToUpdate.forEach((key) => {
      let newVar = globalOnDemandVars[key]()

      let shouldUpdate = true

      if (key === 'Window2InitialValue') {
        if (process.env.NODE_ENV !== 'production') {
          console.tron.display({
            name: 'generateNextInitialValue 3',
            value: {
              newVar: globalOnDemandVars[key](),
              newVarForGlobalId: globalOnDemandVars.Window2InitialValueForGlobalId()
            }
          // , important: true
          })
        }

        newVar = globalOnDemandVars.Window2InitialValueForGlobalId()
      }

      if (shouldUpdate) { inputObj[key] = typeof newVar === 'object' ? JSON.stringify(newVar) : newVar }
    })
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('appsync update 1.5')
    }
    mutateConfigAsync(inputObj)
    // if (notAsync) {
    //   mutateConfig(inputObj)
    // } else {
    //   mutateConfigAsync(inputObj)
    // }
  }
}

export const resetConfig = async () => {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  return mutateConfigAsync(produce(configInitialValues, draft => {
    delete draft.todoListItems
    delete draft.lastClosedList
  }))
}

// -----------------------------------------------------------------------------------------------------------

const mutateChatMemoAsync = async (inputObj) => {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  if (globalOnDemandVars.chatMemoReady()) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'appsync update 2 / ChatMemo',
        value: {
          inputObj
        }
      // , important: true
      })
    }
    try {
      savingStart()
      await Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('Config').doc('chatMemo').update({
        value: inputObj.value
      })
      savingEnd()
    } catch (e) {
      handleErrorInCatch(e, 'updateData.js')
    }
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('appsync update 3')
    }
  }
}

function updateChatMemoToCloud (value) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  if (globalOnDemandVars.chatMemoReady()) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('appsync update 1')
    }
    // const inputObj = {}
    //
    // const keys = ['chatMemoValue']
    //
    // keys.forEach((key) => {
    //   const newVar = globalOnDemandVars[key]()
    //   // inputObj[key] = typeof newVar === 'object' ? JSON.stringify(newVar) : newVar
    //   inputObj[key] = newVar === '' ? null : newVar
    // })
    // console.tron.log('appsync update 1.5')
    mutateChatMemoAsync({ value })
    // if (notAsync) {
    //   mutateChatMemo(inputObj)
    // } else {
    //   mutateChatMemoAsync(inputObj)
    // }
  }
}

export const updateChatMemoToCloudDebounced = debounce(updateChatMemoToCloud, (
  (5 * 60000)
  // 200
), {
  leading: false, trailing: true
})

// -----------------------------------------------------------------------------------------------------------

export function initLocalConfigs () {
  for (const configKey of Object.keys(configInitialValuesBase)) {
    globalOnDemandVars[`set_${configKey}`](configInitialValuesBase[configKey])
  }
}

// -----------------------------------------------------------------------------------------------------------
// window.addEventListener('beforeunload', function (event) {
//   if (!globalOnDemandVars.isSharing() && globalOnDemandVars.userData() && !(globalOnDemandVars.userData().isAnonymous)) {
//     updateConfigToCloud()
//     updateChatMemoToCloud(globalOnDemandVars.chatMemoValue())
//     if (process.env.NODE_ENV !== 'production') {
//       console.tron.log('beforeunload')
//     }
//   }
// })
